import 'bootstrap';
import './utils/hoverintent';
import './component/menu-wrapper';
import './component/menu-dropdown';
import './component/menu-touch';
import './component/menu-language';
import './component/fixed-contact';
import './section/akkordeon';
import './section/buehne';
import './section/modal';
import './section/projekt';
import './section/galerie';
import './section/slidermittextoverlay';
import './section/stichworte';
import './section/widgetintegration';
import AOS from 'aos';
import lightGallery from 'lightgallery.js';

$(document).ready(function () {


    AOS.init({
    });

    $('body').lightGallery({
        selector: '.lightgallery',
        thumbnail: false,
        share: false,
        rotate: false,
        download: false
    });
    $('.lightgallery').wrap('<div class="lightgallery-wrapper"></div>');
    $('.no-lightgallery').wrap('<div class="lightgallery-wrapper"></div>');

});
